export default __webpack_public_path__ + "static/6813-84c7b89f91de62eca09dc8f955746ead.jpg";